<template>
  <section class="content">
    <table class="table table-hover w-100" ref="tbluserkurir">
      <thead>
        <tr>
          <th>Nama</th>
          <th>Email</th>
          <th>Kurir</th>
          <th>Kontak HP</th>
          <th>Active</th>
        </tr>
      </thead>
      <tbody @click="handleClick"></tbody>
    </table>
    <div
      class="modal"
      tabindex="-1"
      role="dialog"
      ref="formDialog"
      data-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <form role="form" @submit="submitForm">
            <div class="modal-header">
              <h5 class="modal-title">{{ formTitle }}</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p v-if="errors.length" class="alert alert-danger">
                <b>Please correct the following error(s):</b>
              </p>
              <div class="row">
                <div class="col-md-6 form-group">
                  <label class="control-label">Nama</label>
                  <input
                    id="name"
                    class="form-control"
                    v-model="form.name"
                    type="text"
                    required="required"
                    name="name"
                    minlength="4"
                    pattern="([A-z\s]){2,}"
                    placeholder="Nama"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 form-group">
                  <label class="control-label">Email</label>
                  <input
                    id="email"
                    class="form-control"
                    v-model="form.email"
                    type="email"
                    required="required"
                    name="email"
                    placeholder="Email"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 form-group">
                  <label class="control-label">Kurir</label>
                  <select
                    v-model="form.courier_id"
                    id="courier_id"
                    name="courier_id"
                    class="form-control"
                    required="required"
                  >
                    <option
                      v-for="courier in groups"
                      v-bind:key="courier.courier_id"
                      v-bind:value="courier.courier_id"
                    >
                      {{ courier.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 form-group">
                  <label class="control-label">No. HP</label>
                  <input
                    id="phone"
                    class="form-control"
                    v-model="form.phone"
                    type="number"
                    name="phone"
                    onKeyPress="if(this.value.length==20) return false;"
                    placeholder="No. HP"/>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 form-group">
                  <label class="control-label">Password</label>
                  <input
                    id="pass"
                    class="form-control"
                    v-model="form.pass"
                    type="password"
                    name="pass"
                    minlength="8"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 form-group">
                  <label class="control-label"> </label>
                  <input value="1" checked="checked" type="checkbox" name="active" v-model="form.active"/>
                  <label for="active">Active</label>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">
                Save changes
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  <!-- /.content -->
</template>
<script>
import { createTable, authFetch } from "@/libs/hxcore";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
  name: "Data List User Kurir",
  data() {
    return {
      errors: [],
      groups: [],
      method: "",
      roles: "",
      formTitle: "Tambah Data List User Kurir",
      form: {
        name: "",
        email: "",
        courier_id: "",
        phone: "",
        pass: "",
        active: "",
      },
    };
  },
  created: function () {
    this.roles = this.$route.meta.roles;
    console.log("load initial data", this.$route);

    authFetch("/shipper/kurir")
      .then((res) => {
        if (res.status === 201) {
        } else if (res.status === 400) {
        }
        return res.json();
      })
      .then((js) => {
        this.groups = js.data;
      });
  },
  methods: {
    handleClick(e) {
      if (e.target.matches(".link-role")) {
        this.$router.push({ path: "/permit/" + e.target.dataset.id });
        return false;
      }
    },
    submitForm: function (ev) {
      const e = this.$refs;
      var data = Object.keys(this.form)
        .map(
          (key) =>
            encodeURIComponent(key) + "=" + encodeURIComponent(this.form[key])
        )
        .join("&");
      var urlSubmit = "/users/courier";
      if (this.method == "PUT") urlSubmit = "/users/courier/" + this.form.id;

      authFetch(urlSubmit, {
        method: this.method,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: data,
      })
        .then((res) => {
          if (res.status === 201) {
          } else if (res.status === 400) {
          }
          return res.json();
        })
        .then((js) => {
          this.errors = [];
          if (!js.success) {
            console.log(js.details);

            for (var key in js.details) {
              if (js.details.hasOwnProperty(key)) {
                this.errors.push(js.details[key]);
              }
            }

            return;
          }
          this.table.api().ajax.reload();
          $(e.formDialog).modal("hide");
        });

      ev.preventDefault();
    },
  },
  mounted() {
    const e = this.$refs;
    var self = this;
    this.table = createTable(e.tbluserkurir, {
      title: "Data List User Kurir",
      roles: this.$route.params.roles,
      ajax: "/users/courier",
      scrollX: true,
      processing: true,
      language: {
        processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'},
      columns: [
        { data: "name" },
        { data: "email" },
        { data: "prefix" },
        { data: "phone" },
        { data: "active" },
      ],
      filterBy: [0, 1, 2],
      rowCallback: function (row, data) {
        if (data.active > 0)
          $("td:eq(4)", row).html(
            '<span class="badge badge-success">Active</span>'
          );
        else
          $("td:eq(4)", row).html(
            '<span class="badge badge-warning">Not Active</span>'
          );
      },
      buttonClick: (evt) => {
        if (evt.role == "create") {
          self.form = {};
          self.method = "POST";
          self.errors = [];
          self.formTitle = "Tambah List User Kurir";
          $(e.formDialog).modal("show");
        } else if (evt.role == "update" && evt.data) {
          self.form = evt.data;
          if (evt.data.active < 1 || !evt.data.active) {
            self.form.active = false;
          } else {
            self.form.active = true;
          }
          self.method = "PUT";
          self.errors = [];
          self.formTitle = "Edit List User Kurir";
          $(e.formDialog).modal("show");
        } else if (evt.role == "delete" && evt.data) {
          // self.form = evt.data;
          console.log(evt);
          Swal.fire({
            title: "Hapus data?",
            icon: "question",
            denyButtonText: '<i class="fa fa-times"></i> Hapus',
            showCancelButton: true,
            showDenyButton: true,
            showConfirmButton: false,
          }).then((result) => {
            if (result.isDenied) {
              authFetch("/users/courier/" + evt.data.id, {
                method: "DELETE",
                body: "id=" + evt.data.id,
              })
                .then((res) => {
                  return res.json();
                })
                .then((js) => {
                  this.table.api().ajax.reload();
                });
            }
          });
        }
      },
      initComplete: function () {
        $('.loading-overlay').removeClass('show');
      },
    });
  },
};
</script>